
import website from '@/config/website';
import { Lang } from '@/lang/lang.js';

// 语言下拉选项常量
export const ALL_LANGUAGE_OPTIONS = [
  {key: 'en-US', icon: 'usa', name: 'EN', value: 'English', desc: '英文', labelKey: 'english', i18nValue: Lang.label.english},
  {key: 'zh-CN', icon: 'china', name: 'CN', value: '中文简体', desc: '中文简体', labelKey: 'chinese', i18nValue: Lang.label.chinese},
  {key: 'zh-TW', icon: 'china', name: 'TW', value: '中文繁体', desc: '中文繁体', labelKey: 'chinaTw', i18nValue: Lang.label.chinaTw},
  {key: 'th-TH', icon: 'thai', name: 'TH', value: 'ภาษาไทย', desc: '泰语', labelKey: 'thai', i18nValue: Lang.label.thai},
  {key: 'es-MX', icon: '', name: 'MX', value: 'Mexican Spanish', desc: '墨西哥-西班牙语', labelKey: 'spain', i18nValue: Lang.label.spain},
  {key: 'id-ID', icon: 'ind', name: 'ID', value: 'Indonesia', desc: '印度尼西亚-印尼语', labelKey: 'indonesia', i18nValue: Lang.label.indonesia},
];

export const getCountryLangOptions = (flag, langKey = import.meta.env.VITE_APP_LANGUAGE) => {
  const lang = langKey ; // 设置默认值 通过.env.production配置获取
  const languageKeys = website.languages[lang] || website.languages[import.meta.env.VITE_APP_LANGUAGE];
  const newOptions = [];
  const localLanguage = ALL_LANGUAGE_OPTIONS.find(item => item.key === lang);
  // 本地语言优先
  if (localLanguage && flag) {
    newOptions.push(localLanguage);
  }
  languageKeys.forEach(key => {
    if (flag) {
      if (lang !== key) { // 跳过本地
        const language = ALL_LANGUAGE_OPTIONS.find(lang => lang.key === key);
        if (language) {
          newOptions.push(language);
        }
      }
    } else {
      const language = ALL_LANGUAGE_OPTIONS.find(lang => lang.key === key);
      newOptions.push(language);
    }
  });
  return newOptions;
  // const languageKeys = ['zh-CN', 'en-US', 'id-ID'];
  // return ALL_LANGUAGE_OPTIONS.filter(item => languageKeys.includes(item.key));
}

export const LANGUAGE_OPTIONS = getCountryLangOptions(true);
export const UN_SORT_LANGUAGE_OPTIONS = getCountryLangOptions(false);

